import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'rtPreventOrphans',
  standalone: true,
})
export class PreventOrphansPipe implements PipeTransform {
  public transform(value: string): string {
    const valueChunks = value.split(' ');
    return valueChunks.slice(0, valueChunks.length - 1).join(' ') + `&nbsp;${valueChunks.pop()}`;
  }
}
